import styles from './calculatorOutro.module.scss';

export const CalculatorOutro = () => {
  return (
    <section className={styles.outro} aria-labelledby="dog-cost-outro-heading">
      <h2 id="dog-cost-outro-heading" className={styles.title}>
        How much does a dog cost per year in Canada?
      </h2>
      <div className={styles.outroText}>
        <p>
          Most obvious are the upfront costs of bringing home a new pup. But,
          what about planning for the ongoing costs over the course of this
          decade-long commitment? Many new dog owners have questions about the
          average cost of owning a dog per year in Canada. Not being able to
          afford these ongoing (or unexpected) expenses accounts for one of the
          biggest reasons why pups end up in shelters and rescues. How are
          prospective pup parents realistically supposed to plan for costs down
          the road? No one knows the future, but considering a realistic budget
          is an admirable start.
        </p>
        <p>
          Unfortunately for Canadians, there are very few accurate resources out
          there to help prospective dog owners calculate the annual cost of a
          dog. In 2019, Global News published an{' '}
          <a
            href="https://globalnews.ca/news/4979041/how-much-does-cost-own-dog/"
            title="Global News article on dog ownership costs"
            rel="noopener noreferrer"
            target="_blank"
          >
            article on dog ownership costs
          </a>
          &nbsp;with 3 case studies of dog ownership and the conclusion of the
          article was that these 3 families’ annual cost ranged from $1,646 -
          $14,820. That’s a massive spectrum of expenses, and therefore, not so
          helpful in estimating one’s own potential experience. So, bookmark and
          share Paction’s calculator to help you and your family calculate the
          cost of owning a dog each year in Canada.
        </p>
      </div>
    </section>
  );
};
